module.exports = __webpack_public_path__ + "img/watch_8.70bd3cc9.jpg";